/**
 * @desc ui自动测试专用
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** amount */
  amount?: number
  /** appkey */
  appkey?: string
  /** merchantNo */
  merchantNo?: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/getUiTestPayUrl',
    data: params,
    method: 'options',
  })
}
